import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

import { videoViewsAvgTimeWatchedConfig } from '../videoViewsAvgTimeWatched';

export const videoViewsAvgTimeWatchedMVConfig = {
    ...videoViewsAvgTimeWatchedConfig,
    tooltip: false,
    name: 'kpi.facebook.avg_time_watched',
    id: 'video_views_avg_time_watched',
    size: SIZE_50,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
